import { useMemo } from "react"
import { WearableModalType } from "../types"
import WearableContentInfo from "../WearableContentInfo"

interface WearableConnectedInfoProps {
   type:
      | WearableModalType.ASSIGNED
      | WearableModalType.SWAPPED
      | WearableModalType.DISCONNECTED
}

const WearableConnectedInfo = ({ type }: WearableConnectedInfoProps) => {
   const description = useMemo(() => {
      switch (type) {
         case WearableModalType.ASSIGNED:
            return "The ReassureBand is now assigned to the inmate."
         case WearableModalType.SWAPPED:
            return "Swap successfully completed, new ReassureBand is assigned to the inmate. Scan a new ReassureBand or close modal to continue."
         case WearableModalType.DISCONNECTED:
            return "This ReassureBand has been successfully disconnected, the inmate no longer has an assigned ReassureBand."
         default:
            return ""
      }
   }, [type])

   return (
      <WearableContentInfo
         type={type}
         description={
            <div className="wearable-content-info__description">
               <div>{description}</div>
            </div>
         }
      />
   )
}

export default WearableConnectedInfo
